import { ChangeDetectorRef, Component, inject, OnInit, viewChild } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { ActivatedRoute, NavigationEnd, Router } from '@angular/router';
import { AppPages } from '@app/app.pages';
import { BaseComponent } from '@app/components/base/base.component';
import { AppsStarterComponent } from '@app/components/header/apps-starter/apps-starter.component';
import { AuthState } from '@app/enum/auth-state.enum';
import { AuthService } from '@app/services/auth/auth.service';
import { CategoriesGroupsService } from '@app/services/categories-groups/categories-groups.service';
import { AnalyticsService } from '@services/analytics/analytics.service';
import { SearchUiService } from '@services/search/search-ui.service';
import { filter, map } from 'rxjs';

@Component({
  selector: 'app-base-header',
  template: ''
})
export abstract class HeaderComponent extends BaseComponent implements OnInit {
  private readonly activatedRoute: ActivatedRoute = inject(ActivatedRoute);
  private readonly analyticsService: AnalyticsService = inject(AnalyticsService);
  public categoryGroupId: string | null = null;
  public readonly AppPages = AppPages;
  public readonly appsStarterComponent = viewChild.required<AppsStarterComponent>(AppsStarterComponent);
  public readonly authService: AuthService = inject(AuthService);
  public readonly authState = AuthState;
  public readonly categoriesGroupsService: CategoriesGroupsService = inject(CategoriesGroupsService);
  public readonly changeDetectorRef: ChangeDetectorRef = inject(ChangeDetectorRef);
  public readonly router: Router = inject(Router);
  public readonly searchUiService: SearchUiService = inject(SearchUiService);

  constructor() {
    super();
    this.router.events
      .pipe(
        filter(event => event instanceof NavigationEnd),
        map(() => this.activatedRoute),
        map(route => {
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter(route => route.outlet === 'primary'),
        map(route => route.snapshot.params['categoryGroupId'])
      )
      .pipe(takeUntilDestroyed())
      .subscribe(categoryGroupId => {
        this.categoryGroupId = categoryGroupId;
        this.changeDetectorRef.detectChanges();
      });
  }

  public ngOnInit(): void {
    this.data = this.categoriesGroupsService.getItems().pipe(map(items => items));
  }

  public logout(): void {
    this.authService.logout();
  }

  public openAppsStarter(): void {
    this.appsStarterComponent().openDialog();
  }

  public openGlobalSearch(trigger?: EventTarget | null): void {
    this.closeDropdowns();
    const element = trigger instanceof HTMLElement ? trigger : undefined;
    this.analyticsService.trackEvent('global_search', 'open', 'header_click');
    this.searchUiService.open(element);
  }

  // Method to be overridden by child components to close dropdowns
  public closeDropdowns(): void {
    // Override in child components
  }
}
